import axios from 'axios'
import { REACT_APP_API } from '../../config'

export default async function generateCSV(
    selectedAttribute,
    attributeList,
    dataValues,
    columnData
) {
    const body = {
        selectedAttribute,
        attributeList,
        dataValues,
        columnData
    }

    const { data } = await axios.post(
        `${REACT_APP_API}/dashboard/generateCSV`,
        body,
        {
            responseType: 'arraybuffer'
        }
    )

    if (data) {
        const blob = new Blob([data])
        const fileURL = URL.createObjectURL(blob)
        let a = document.createElement("a") 
        a.download = 'Reporte dashboard.csv'
        a.href = fileURL
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        return true
    } else return null
}
